'use client';

import '@chewy/kib-content-groups-styles/dist/styles/kib-accordion-new.css';

import { KibAccordionNew, KibAccordionNewItem } from '@chewy/kib-content-groups-react';
import cx from 'classnames';

import { FaqData } from './faq-data';
import styles from './styles.module.scss';

export const FAQ = ({ faqs, className }: { faqs?: FaqData[]; className?: string }) => {
  if (!faqs || faqs.length === 0) {
    return null;
  }

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <div className={cx(styles.faq, className)}>
      <script
        data-testid="faq-schema"
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <KibAccordionNew>
        {faqs.map((item, index) => (
          <KibAccordionNewItem key={index} title={item.question}>
            <p>{item.answer}</p>
          </KibAccordionNewItem>
        ))}
      </KibAccordionNew>
    </div>
  );
};
